<template>
  <div style="height: 100%" class="el-dialog--center">
    <div class="el-dialog__header">
      <slot name="title">
        <span v-if="title" class="el-dialog__title">{{ title }}</span>
      </slot>
      <button type="button" class="el-dialog__headerbtn" @click="$parent.$emit('close')">
        <i class="iconfont icon-close_s"></i>
      </button>
    </div>
    <div class="the-height el-dialog__body">
      <slot name="default"></slot>
    </div>
    <!-- <div class="el-dialog__footer">
      <slot name="footer">
        <el-button @click="$parent.$emit('close')">取 消</el-button>
        <el-button type="primary" @click="$emit('submit')">确 定</el-button>
      </slot>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'template-dialog-wraper',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss">
.el-dialog__headerbtn {
  i {
    font-size: 24px;
    color: #ffffff;
  }
}
</style>
